module.exports = __webpack_public_path__ + "img/remove-off.9d54941e.svg";